import style from './express-workout-home-card-list.module.scss'
import { ExpressWorkoutHomeCardSkeleton } from './express-workout-home-card-skeleton'
import React from 'react'
import { Container } from 'react-bootstrap'

export const ExpressWorkoutHomeCardListSkeleton = (): React.ReactElement => {
  return (
    <Container fluid className="px-0">
      <div className={style.container}>
        <div className={style.largeCardColumn}>
          <ExpressWorkoutHomeCardSkeleton isLarge={true} />
        </div>
        <div className={style.smallCardsColumn}>
          <div className={style.masonryGrid}>
            {Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className={style.masonryItem}>
                <ExpressWorkoutHomeCardSkeleton isLarge={false} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  )
}
